import { Box } from '@cad-arc';
import { colors } from '../colors/colors';
import { sensorEventsPalette } from './sensor-events-palette';

/**
 * The severity dot on every sensor event surface: the event queue's Priority 1 colour for an alert
 * whose mapped priority is Priority 1, the detection colour for everything else. Priority 1 is the
 * one level CAD colours anywhere, so it is the only one given its own here. See
 * `useSensorPriority`.
 */
export function SensorSeverityDot({
    size = 8,
    isPriority1 = false,
}: {
    size?: number;
    isPriority1?: boolean;
}): React.ReactElement {
    return (
        <Box
            width={`${size}px`}
            height={`${size}px`}
            borderRadius="full"
            flexShrink={0}
            style={{
                backgroundColor: isPriority1
                    ? colors.queuePriority
                    : sensorEventsPalette.severityDetection,
            }}
            data-testid="SENSOR_SEVERITY_DOT"
            data-priority-1={isPriority1 || undefined}
        />
    );
}
